export const defaultCountry = "USA";
export const defaultBoderlessCountryName = "UNITED STATES OF AMERICA";
export const defaultCurrency = "USD";

export const relationOptions = [
  { label: "Father", value: "FATHER" },
  { label: "Step Father", value: "STEP FATHER" },
  { label: "Mother", value: "MOTHER" },
  { label: "Step Mother", value: "STEP MOTHER" },
  { label: "Son", value: "SON" },
  { label: "Step Son", value: "STEP SON" },
  { label: "Son's Wife", value: "SON'S WIFE" },
  { label: "Daughter", value: "DAUGHTER" },
  { label: "Daughter's Husband", value: "DAUGHTER'S HUSBAND" },
  { label: "Brother", value: "STEP BROTHER" },
  { label: "Step Brother", value: "STEP BROTHER" },
  { label: "Sister", value: "SISTER" },
  { label: "Step Sister", value: "STEP SISTER" },
  { label: "Husband", value: "HUSBAND" },
  { label: "Wife", value: "WIFE" },
];

export const remitterTypeOptions = [
  { label: "Guardian", value: "Guardian" },
  { label: "Self", value: "Self" },
];
